import { useTranslation } from 'react-i18next';
import { Textarea } from '@/components/ui/Textarea';
import { Select } from '@/components/ui/Select';
import { StepProps } from '../types';

/**
 * AudienceStep - Step 2 of AI Briefing Wizard
 *
 * Collects target audience, additional context, and content format.
 * All fields in this step are optional except contentFormat (has default).
 */

interface FormatOption {
  value: 'text' | 'image_text' | 'video_text' | 'carousel_text';
  label: string;
}

const FORMAT_OPTIONS: FormatOption[] = [
  { value: 'text', label: 'ai_briefing_format_text' },
  { value: 'image_text', label: 'ai_briefing_format_image_text' },
  { value: 'video_text', label: 'ai_briefing_format_video_text' },
  { value: 'carousel_text', label: 'ai_briefing_format_carousel_text' },
];

export const AudienceStep = ({ formData, onFieldChange, errors }: StepProps) => {
  const { t } = useTranslation('ai');

  return (
    <div className="space-y-5">
      {/* Target Audience */}
      <Textarea
        label={t('ai_briefing_audience_label')}
        placeholder={t('ai_briefing_audience_placeholder')}
        value={formData.audience}
        onChange={(e) => onFieldChange('audience', e.target.value)}
        error={errors?.audience}
        rows={2}
      />

      {/* Additional Context */}
      <Textarea
        label={t('ai_briefing_context_label')}
        placeholder={t('ai_briefing_context_placeholder')}
        value={formData.context}
        onChange={(e) => onFieldChange('context', e.target.value)}
        error={errors?.context}
        rows={2}
      />

      {/* Content Format */}
      <Select
        label={t('ai_briefing_format_label')}
        options={FORMAT_OPTIONS.map((opt) => ({
          value: opt.value,
          label: t(opt.label),
        }))}
        value={formData.contentFormat}
        onValueChange={(value) =>
          onFieldChange('contentFormat', value as 'text' | 'image_text' | 'video_text' | 'carousel_text')
        }
        error={errors?.contentFormat}
      />
    </div>
  );
};
